export const STOCK_ALERT_LIST_ATTEMPT = 'STOCK_ALERT_LIST_ATTEMPT';
export const STOCK_ALERT_LIST_SUCCESS = 'STOCK_ALERT_LIST_SUCCESS';
export const STOCK_ALERT_LIST_FAILED = 'STOCK_ALERT_LIST_FAILED';
export const STOCK_ALERT_NEW_SUCCESS = 'STOCK_ALERT_NEW_SUCCESS';
export const STOCK_ALERT_NEW_FAILED = 'STOCK_ALERT_NEW_FAILED';
export const STOCK_ALERT_REMOVE_SUCCESS = 'STOCK_ALERT_REMOVE_SUCCESS';
export const STOCK_ALERT_REMOVE_FAILED = 'STOCK_ALERT_REMOVE_FAILED';
